import { productionUrl } from '@/app/util/env'
import Link from 'next/link'

const AnimatedLogo = () => {
    return (
        <Link
            className="flex w-[185px] items-center justify-center bg-transparent hover:cursor-pointer"
            href="/"
            prefetch={false}
        >
            <img
                src={`${productionUrl}/static/img/giphy-logo.webp`}
                className="ci-hidden mt-2 mr-[16px]"
                alt="GIPHY Logo"
            />
        </Link>
    )
}

export default AnimatedLogo
